import impactBaseLogo from "../assets/impactbase-logo.png";
import spacem8Logo from "../assets/spacem8-logo.png";
import tibagridHmsIcon from "../assets/tibagrid-hms-icon.png";
import tibagridHmsLogo from "../assets/tibagrid-hms-logo.png";
import vertexLocomotivesLogo from "../assets/vertex-locomotives-logo.png";

export const products = [
  {
    slug: "spacem8",
    title: "Space-m8",
    category: "Property management platform",
    logo: spacem8Logo,
    logoAlt: "Space-m8 logo",
    description:
      "Space-m8 is a property management app built to help property teams manage spaces, tenants, operations, and day-to-day coordination through a cleaner and more intelligent digital experience.",
    highlights: [
      "Property operations in one place",
      "Smarter coordination across spaces and teams",
      "A more intelligent experience for modern property management",
    ],
  },
  {
    slug: "impactbase",
    title: "ImpactBase",
    category: "NGO management platform",
    logo: impactBaseLogo,
    logoAlt: "ImpactBase logo",
    description:
      "ImpactBase is a fully integrated, web-based management platform purpose-built for non-governmental organisations. It unifies project management, procurement, and human resources in one system with embedded compliance controls designed for NGO operations.",
    highlights: [
      "Donor budget restrictions and policy enforcement",
      "Competitive bidding, approvals, and vendor due diligence",
      "Tamper-proof audit trail across NGO workflows",
    ],
  },
  {
    slug: "vertex-locomotives",
    title: "Vertex Locomotives",
    category: "Automotive commerce and experiences",
    logo: vertexLocomotivesLogo,
    logoAlt: "Vertex Locomotives logo",
    description:
      "Vertex Locomotives is a platform for car sales, garage services, and safari offerings, bringing mobility commerce and customer experience together in one digital ecosystem.",
    highlights: [
      "Vehicle listings and car selling workflows",
      "Garage service visibility and customer access",
      "Safari offerings connected to a broader mobility brand",
    ],
  },
  {
    slug: "tibagrid-hms",
    legacySlugs: ["afyaflow-hms"],
    title: "TibaGrid HMS",
    category: "AI-powered healthcare operations platform",
    logo: tibagridHmsLogo,
    icon: tibagridHmsIcon,
    logoAlt: "TibaGrid HMS logo",
    logoSurface: "light",
    logoClassName: "max-h-32 md:max-h-36",
    description:
      "TibaGrid HMS is an AI-powered hospital management system designed to help clinics and hospitals digitize patient records, streamline appointments, manage consultations, automate lab and pharmacy workflows, handle billing and claims, and turn healthcare operations into intelligent real-time insights.",
    highlights: [
      "Digitized patient records, appointments, and consultations in one system",
      "Connected lab, pharmacy, billing, and claims workflows",
      "AI intelligence that turns healthcare operations into real-time insight",
    ],
  },
];

export function getProductBySlug(slug) {
  return products.find(
    (product) => product.slug === slug || product.legacySlugs?.includes(slug)
  );
}
